import type { ReactNode } from 'react';

import { ICON_WEIGHT, type IconComponent } from './icon';

interface EmptyStateProps {
  icon: IconComponent;
  title: string;
  description: ReactNode;
  children?: ReactNode;
}

/**
 * The shell's placeholder until each feature lands. Phase 7 replaces the copy
 * with real onboarding; the shape stays: what this is, and what to do next.
 *
 * No card. A dashed boundary and space carry the "nothing here yet" reading
 * without pretending an empty region has elevation.
 */
export function EmptyState({ icon: Icon, title, description, children }: EmptyStateProps) {
  return (
    <section className="border-border rounded-container border border-dashed px-4 py-14 text-center sm:px-6">
      <Icon
        aria-hidden="true"
        weight={ICON_WEIGHT}
        className="text-muted-foreground mx-auto size-7"
      />
      <h1 className="mt-4 text-lg font-semibold tracking-tight">{title}</h1>
      <div className="text-muted-foreground mx-auto mt-2 max-w-[60ch] text-sm leading-relaxed">
        {description}
      </div>
      {children ? <div className="mt-6 flex justify-center gap-3">{children}</div> : null}
    </section>
  );
}
